<template>
  <div>
    <v-card :loading="loading" v-if="user">
      <v-card-title primary-title>
        Search by CUSIP
        <v-spacer />
        <v-select
          v-if="userCanSeeRandomButton"
          v-model="securityType"
          outlined
          dense
          color="purple"
          hide-details
          :items="securityTypes"
          label="security type"
          class="purple-text"
          style="max-width:150px;"
        />
        <v-btn
          v-if="userCanSeeRandomButton"
          color="purple"
          outlined
          @click="getRandomCusip"
        >
          <v-icon class="mr-1">
            mdi-shuffle-variant
          </v-icon>
          Random
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row align="center">
          <v-col cols="7">
            <v-text-field
              v-model="newCusip"
              filled
              label="CUSIP"
              clearable
              hide-details
              :value="bob"
            />
          </v-col>
          <v-col cols="3">
            <v-btn color="primary"
              @click="updateCusip"
            >
              <v-icon class="mr-1">
                mdi-magnify
              </v-icon >
              Search
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data: () => ({
    securityTypes: ['cmbs', 'crt', 'pt', 'na'],
    securityType: null,
    newCusip: null,
    bob: null
  }),
  computed: {
    ...mapState({
      cusip: 'currentCusip',
      loading: 'loading',
      user: 'user'
    }),
    userCanSeeRandomButton: function() {
      /* yes, it's not ideal to hard code Alexa's user ID here */
      return this.user && this.user.account && (this.user.account.id === 1 || this.user.account.id === 20 || this.user.user_id == 248)
    }
  },
  methods: {
    getRandomCusip() {
      this.$store.dispatch('getCusipData', `random?st=${this.securityType}`)
      this.$router.push({name: 'Securities'})
    },
    updateCusip() {
      this.$store.dispatch('getCusipData', this.newCusip)
      this.$router.push({name: 'Securities', params: {cusip: this.newCusip}})
    }
  },
  watch: {
    cusip: function(c) {
      this.newCusip = c
    }
  }

}
</script>
<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: rgba(192, 0, 250, 0.986) !important;
}
</style>
